import { useMemo } from 'react';

import { IFetchPlanDetailsResult, SKU, useMembershipPlans } from '~/src/common/brooklyn';

export function usePlanDetailsBySku(sku: SKU): IFetchPlanDetailsResult {
  const { loading, error, getPlan, called } = useMembershipPlans();

  const planDetails = getPlan({ sku }) ?? null;

  const result = useMemo(
    () => ({
      loading,
      error,
      plan: planDetails,
      called,
    }),
    [called, planDetails, error, loading],
  );

  return result;
}
